<div class="project-page">
<!--  <div class="detail-shell" [ngStyle]="{'bottom': footerHeight + 10 + 'px'}">-->
    <header class="project-header">
      <p class="eyebrow">Portfolio :: App With Location Service</p>
      <h1>App With Location Service</h1>
      <div class="meta-badges">
        <span>Google Maps</span>
        <span>Android</span>
        <span>Java</span>
        <span>Android</span>
      </div>
    </header>

    <div class="content-grid">
      <section class="project-copy">
        <p>
          This Android application brings together live location tracking and map visualization to help
          compare the receiver’s position with the client’s current position.
        </p>

        <ul class="feature-list">
          <li>Retrieve receiver location data from an online source.</li>
          <li>Capture the client’s current coordinates from the device.</li>
          <li>Calculate the exact distance between both points.</li>
          <li>Render the receiver, the client, and the connecting line on a Google Map.</li>
          <li>Use a custom logging system to track runtime events and diagnostics.</li>
        </ul>
      </section>

      <aside class="project-visual">
        <img class="phone-shot" src="../../../../assets/images/app-location1.png"
             alt="App With Location Service screenshot">
      </aside>
    </div>
<!--  </div>-->
</div>

